import React, { useContext, useRef } from 'react';
import UiContext from 'common/UiContext/UiContext';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

import InfoText from 'components/InfoText';

import IDashboardData from 'pages/Dashboard/IDashboardData';
import Loading from 'components/Loading';
import classNames from 'classnames';

const PoolInformation = ({ data, isLoading }: { data: IDashboardData, isLoading: boolean }) => {
  const { openModal } = useContext(UiContext);
  const ref = useRef(null);

  return(
    <>
      <h3>Pool Information</h3>
      <SwitchTransition>
        <CSSTransition
          nodeRef={ref}
          classNames='fade'
          timeout={300}
          mountOnEnter={true}
          unmountOnExit={true}
          key={isLoading ? 1 : 0}
        >

          <div ref={ref} className={classNames({ box: true, isLoading })}>
            {isLoading && <Loading />}
            <InfoText content={[data?.stratum_url_1 ?? '...']} title='Stratum URL 1' copyable={true} />
            <InfoText content={[data?.stratum_url_2 ?? '...']} title='Stratum URL 2' copyable={true} />
            <InfoText content={[data?.stratum_url_3 ?? '...']} title='Stratum URL 3' copyable={true} />
            <InfoText content={[
              `userID: ${data?.pool_user ?? '...'}`,
              `password: ${data?.pool_pass ?? '...'}`,
            ]} />
            <button className='primary small' onClick={() => openModal!('ConnectWorkers')}>View More Info</button>
          </div>
        </CSSTransition>
      </SwitchTransition>
    </>
  );
};

export default PoolInformation;